class PardotLazyLoad {
	static init() {
		const frames = document.querySelectorAll('iframe[data-pardot-src]');
		if (!frames.length) return;

		if (!('IntersectionObserver' in window)) {
			frames.forEach((frame) => PardotLazyLoad.load(frame));
			return;
		}

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return;
					observer.unobserve(entry.target);
					PardotLazyLoad.load(entry.target);
				});
			},
			{ rootMargin: '300px 0px' }
		);

		frames.forEach((frame) => observer.observe(frame));
	}

	static load(frame) {
		frame.src = frame.dataset.pardotSrc;
		frame.removeAttribute('data-pardot-src');
	}
}

export default PardotLazyLoad;
